import React, {useEffect} from "react";
import {useTheme, withStyles} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ReactAudioPlayer from "react-audio-player";
import {Button, Typography} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import CloseIcon from "@material-ui/icons/Close";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import DialogActions from "@material-ui/core/DialogActions";
import AuthProvider from "../../../provider/AuthProvider";

/**
 * 측정을 위한 알림 및 카운트다운
 */
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={clsx('common-dialog-close', classes.closeButton)}   onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


export function StartMeasureDialog(props) {
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(()=>{
        setOpen(props.open)
    },[props.open])

    
    let audio = '04'
    let showClose = true
    let body = ` 항상성 자기조절 측정을 시작하겠습니다. 
                움직이지 마시고 편안한 마음으로 화면을 바라보시기 바립니다.
                눈을 뜬 상태에서 측정합니다.`
    if('MM' === props.measureCode){
        audio = '04-01'
        body = '눈을 감으세요'
        showClose = false
    } else if ('MB' === props.measureCode){
        audio = '04-02'
        body = '눈을 뜨세요'
        showClose = false
    }

    let title = '항상성 자기조절';
    return (
        <Dialog
            disableBackdropClick
            fullScreen={fullScreen}
            open={open}
            aria-labelledby="responsive-dialog-title"
            className={'innerViewport'}
        >
            <DialogTitle  className="common-dialog-title" onClose={() => {
                props.history.replace('/measureSelect')
            }}>
                {title}
            </DialogTitle>
            <DialogContent className={'common-dialog-content'}>
                {body}
                <br/>
                <br/>
                <ReactAudioPlayer
                    src={require(`@audio/${audio}.mp3`)}
                    autoPlay
                    controls
                    onEnded={()=>{
                        setOpen(false)
                        if(props.onHide){
                            props.onHide()
                        }
                    }}
                />
            </DialogContent>
            {showClose && !AuthProvider.isCustomerView() &&
            <DialogActions className={'common-dialog-action'}>
                <Button
                    autoFocus
                    fullWidth={true}
                    endIcon={<ArrowForwardIosIcon/>}
                    onClick={() => {
                        setOpen(false)
                        if (props.onHide) {
                            props.onHide()
                        }
                    }}>
                    측정시작
                </Button>
            </DialogActions>
            }
        </Dialog>
    );
}

export default StartMeasureDialog